module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-02-on.975937fc.jpg";